import { formatUkRegistration } from "../utils/registration";

export default function Plate({ registration, compact = false }) {
  const display = formatUkRegistration(registration);
  return (
    <span className={compact ? "mini-plate" : "plate"}>
      {compact ? display : (
        <>
          <span className="flag"><img src="/gb-flag.svg" alt="" />UK</span>
          <strong className="reg">{display}</strong>
        </>
      )}
    </span>
  );
}
